import React, { ReactElement, ReactNode } from 'react'
import { observer } from 'mobx-react'
import { PermissionType, usePermissions } from '../util/permissions'

interface GateProps {
  permission?: PermissionType | PermissionType[]
  anyOf?: PermissionType[]
  fallback?: ReactNode
  children: ReactNode
}

const Gate = observer(({ permission, anyOf, fallback = null, children }: GateProps): ReactElement => {
  const { has, hasAny } = usePermissions()

  const allowed =
    (permission === undefined || has(...(Array.isArray(permission) ? permission : [permission]))) &&
    (anyOf === undefined || hasAny(...anyOf))

  return <>{allowed ? children : fallback}</>
})

export default Gate
